import template from 'text!./TooltipLabel.html';

export default {
    template,
    bindings: {
        tooltip: '=',
        label: '@'
    }
};